// extracted by mini-css-extract-plugin
export var approach = "homeApproach-module--approach---aNXG";